import React, { useEffect, useRef, useState } from "react";
import { MoreVert } from "../../assets/svg";

const Action = ({ optionList, ulClassName = "min-w-[12rem]" }) => {
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);

  const toggling = () => setOpen(!open);

  useEffect(() => {
    function handler(event) {
      if (!cancelButtonRef.current?.contains(event.target)) {
        setOpen(false);
      }
    }
    window.addEventListener("click", handler);
    return () => window.removeEventListener("click", handler);
  }, []);

  return (
    <div
      className="relative cursor-pointer px-3 py-2 sm:px-2 sm:py-1"
      ref={cancelButtonRef}
      onClick={toggling}
    >
      <MoreVert className="w-5 h-5 sm:w-4 sm:h-4" />

      {open && (
        <ul
          className={`absolute top-[calc(100%+0.4rem)] right-0 bg-white text-primaryBlack 
                     max-h-[250px] sm:max-h-[200px] overflow-auto 
                     rounded-lg shadow-md z-20 text-base ${ulClassName}`}
        >
          {optionList}
        </ul>
      )}
    </div>
  );
};

export default Action;
